import './App.scss';
import * as React from 'react';
import { useState, useEffect } from 'react';
import { Content, Header, Footer, ParticleBackground, CustomCursor, FilmGrain, Bubbles } from './components';
import useTheme from './hooks/useTheme';
import useBackgroundMusic from './hooks/useBackgroundMusic';

function App() {
  const { isDark, toggleTheme } = useTheme();
  const { playing, togglePlay } = useBackgroundMusic(isDark);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const show = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setReady(true);
        });
      });
    };

    // Wait for fonts and initial frame to ensure animations/3D don't glitch
    if (document.fonts && document.fonts.ready) {
      // Timeout fallback in case fonts never resolve
      const timeout = setTimeout(show, 3000);
      document.fonts.ready.then(() => {
        clearTimeout(timeout);
        show();
      }).catch(() => {
        clearTimeout(timeout);
        show();
      });
    } else {
      show();
    }
  }, []);

  return (
      <div className={`base ${ready ? 'base--ready' : 'base--loading'}`}>
        <CustomCursor />
        <ParticleBackground />
        <FilmGrain />
        <Bubbles />
        <Header isDark={isDark} onToggle={toggleTheme} playing={playing} onTogglePlay={togglePlay} />
        <Content/>
        <Footer/>
      </div>
  );
}

export default App;
